'use client';
import React from 'react';

import TextField from '@mui/material/TextField';
import styled from 'styled-components';

import BreadcrumbsWrap from './BreadcrumbsWrap';
import Button from '@/ui/components/Button';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  gap: 1.25rem;
`;

const PasswordCheckWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
`;

const LockIcon = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 1024 1024"
    height="5rem"
    width="5rem"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0z" />
  </svg>
);

/**
 * @todo zabezpeceni proti brute force
 */
export default function PasswordGuard() {
  const [enteredPassword, setEnteredPassword] = React.useState('');
  // const [badPassword, setBadPassword] = React.useState(false);

  const onInputChangeAction = event => {
    setEnteredPassword(event.target.value);
  };

  const checkPassword = () => {
    document.cookie = `password=${enteredPassword}; path=/`;
    window.location.reload();
  };

  return (
    <>
      <BreadcrumbsWrap items={[]} />
      <Wrapper>
        <form autoComplete="off">
          <PasswordCheckWrapper>
            <LockIcon />
            <p>This content is password protected:</p>
            <TextField
              autoComplete="off"
              onChange={onInputChangeAction}
              type="password"
              value={enteredPassword}
              label="Password"
            />
            <Button onClick={checkPassword}>Submit</Button>
            {/* ### <Error> import Error from '../admin/layout/Error'; */}
            {/* {badPassword && <>Wrong password</>} */}
          </PasswordCheckWrapper>
        </form>
      </Wrapper>
    </>
  );
}
